'use client'

import { useContext } from 'react'
import { Switch } from '../../Switch/Switch'
import { ProductFilterFormContext } from '../FilterUtils/ProductFilterFormContext'
import { ConfigContext, useTranslation } from '../../../context/ConfigContext'
import Icon from '../../Icon/Icon'
import { Icons } from '../../Icon/constants'
import { AggregationsFilters } from '../../../../domain/cmsCategory'

const FilterProductFormMenuItem = ({ name, label, onClick, isActive }) => (
  <button
    className={`filter-product-form-menu-filterby-item filter-product-form-menu-filterby-item-${name} ${
      isActive ? 'active' : ''
    }`}
    type='button'
    onClick={() => onClick(name)}>
    <span>{label}</span>
    <Icon iconName={Icons.NAV_ARROW_DOWN} />
  </button>
)

type FilterProductFormOptionFilterListProps = {
  onClick: (name: string) => void
  aggregations: AggregationsFilters
  activeOptionFilter?: string
  categoriesFilters: CategoriesFilters[]
  collectionFilters: CollectionProductFilter[]
}
const FilterProductFormDesktopMenuFilterBy = ({
  onClick,
  aggregations,
  activeOptionFilter,
  categoriesFilters,
  collectionFilters,
}: FilterProductFormOptionFilterListProps) => {
  const { storeConfig } = useContext(ConfigContext)
  const { formState, onChangeAvailableOnline } = useContext(ProductFilterFormContext)
  const t = useTranslation()

  return (
    <div className='filter-product-form-menu-filterby'>
      <p className='filter-product-form-menu-filterby-title'>{t('Filter by')}</p>
      {categoriesFilters.length > 0 && (
        <FilterProductFormMenuItem
          name='type'
          onClick={onClick}
          label={aggregations?.type}
          isActive={activeOptionFilter === 'type'}
        />
      )}
      {collectionFilters.length > 0 && (
        <FilterProductFormMenuItem
          name='collection'
          onClick={onClick}
          label={aggregations?.collection_product}
          isActive={activeOptionFilter === 'collection'}
        />
      )}
      <FilterProductFormMenuItem
        name='color'
        onClick={onClick}
        label={aggregations?.couleur_metal}
        isActive={activeOptionFilter === 'color'}
      />
      {storeConfig.display_prices === 1 && (
        <FilterProductFormMenuItem
          name='price'
          onClick={onClick}
          label={aggregations?.price}
          isActive={activeOptionFilter === 'price'}
        />
      )}
      {storeConfig.ecommerce === 1 && (
        <div className='filter-product-form-menu-filterby-availableonline'>
          <span>{aggregations?.en_vente}</span>
          <Switch
            label=''
            color='white'
            value={formState.availableOnline}
            onChange={onChangeAvailableOnline}
          />
        </div>
      )}
    </div>
  )
}

export default FilterProductFormDesktopMenuFilterBy
